import { TFieldError, validators, TBasicFieldValue } from "react-ocean-forms";


const email = (value) => {
  // chromium validation
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase()) ? undefined : 'ojs_error_email';
};

const typeRequired = (value: TBasicFieldValue): TFieldError => {
  const required = validators.required(value);
  return required ? 'ojs_error_type_required' : undefined;
}

export const customvalidators = {
  email,
  typeRequired
}
